import React from 'react';
import { Icon } from 'ui';
import FeatureFlag from 'components/shared/FeatureFlag';
import Link from '../../_shared/Link.js';

// TODO: refactor this into a reusable component
/* TODO:
 * this component isn't used anymore, but seems to be the genesis of the
 * NewButton styles. I don't want to delete it, but it probably should still
 * be refactored at some point. - Conlin 04/08/19
 */
// eslint-disable-next-line
const NewButton = ({ label, enabled, href, onClick, newKeyword = 'New' }) => (
  <Link
    if={enabled}
    className="NewButton NewButton--white NewButton--center undecorated"
    href={href}
    onClick={onClick}
    forceClick={!href}
  >
    <Icon name="add" className="mr-4" />
    <span className="u-hideBelowXS">{newKeyword}</span> {label}
  </Link>
);

const IndexHeader = ({ title, actions, count, className = '' }) => (
  <div className={`Index-header ${className}`}>
    <h1 className="Index-title">
      <FeatureFlag
        features="readiness-enable-unification"
        fallback={
          <>
            {title} {count && `(${count})`}
          </>
        }
      />
    </h1>
    {actions}
  </div>
);

export default IndexHeader;
